import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { Checkbox, CHECKBOX_SIZE } from '../../../Checkbox'
import { FormFieldsContainer } from '../../../Form'
import { FormikField, getFormikCheckboxFieldValueProps } from '../../../Formik'
import Text from '../../../Text'
import { DocumentAccessLevelField } from '../../DocumentAccessLevelField'
import {
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_INHERIT_PERMISSIONS,
} from '../DocumentEditAccessActionModal.constants'
import { getAdjustedAccessLevels } from '../DocumentEditAccessActionModal.utils'

import {
  ACCESS_FIELD_NAMES,
  ACCESS_ROLE_BY_FIELD,
} from './DocumentEditAccessActionModalFields.constants'

import * as styles from './DocumentEditAccessActionModalFields.module.css'

function DocumentEditAccessActionModalFields({ inheritField }) {
  const { t } = useTranslation()

  const { setFieldValue, values } = useFormikContext()

  function handleChangeAccess(nameKey, nextLevel) {
    setFieldValue(
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS,
      getAdjustedAccessLevels({
        levels: values[DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS],
        nextLevel,
        role: ACCESS_ROLE_BY_FIELD[nameKey],
      })
    )
  }

  return (
    <FormFieldsContainer>
      <div className={styles.accessField}>
        <Text>{t('Modal.DocumentEditAccessActionAccessFieldLabelKey')}</Text>
        <DocumentAccessLevelField
          name={ACCESS_FIELD_NAMES}
          onChangeAccess={handleChangeAccess}
        />
      </div>
      {inheritField ? (
        <div className={styles.accessField}>
          <Text>{`${t('Modal.DocumentEditAccessActionInheritFieldLabelKey')}:`}</Text>
          <FormikField
            Component={Checkbox}
            Field={Fragment}
            getValueProps={getFormikCheckboxFieldValueProps}
            label={t(
              values[DOCUMENT_EDIT_ACCESS_FIELD_NAME_INHERIT_PERMISSIONS]
                ? 'Modal.DocumentEditAccessActionInheritOnKey'
                : 'Modal.DocumentEditAccessActionInheritOffKey'
            )}
            name={DOCUMENT_EDIT_ACCESS_FIELD_NAME_INHERIT_PERMISSIONS}
            size={CHECKBOX_SIZE.small}
          />
        </div>
      ) : null}
    </FormFieldsContainer>
  )
}

export default DocumentEditAccessActionModalFields
